export default {"src":"/_next/static/media/ic-dropdown.328fa220.svg","height":18,"width":18};